import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getCategoryRequest, getCategoryRequestError, getCategoryRequestSuccess } from "../../../slices/teams/members/GetCategorySlice";

export const GetCategoryApi = () => async (dispatch) => {

    const url = `${endpoints.CategoryList}`;
    try {
        dispatch(getCategoryRequest());
        axiosInstance({
            method: "GET",
            url: url,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getCategoryRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getCategoryRequestError(_error));
            });
    } catch (error) { }
};
